import {
  EStoreRedirectEventType,
  type StoreRedirectEvent,
} from '@web-store-platforms/hooks/use-store-redirect';

import {
  EPortalRumEvents,
  logPortalRumError,
  logPortalRumInfo,
} from '@/lib/coralogix';
import {
  finishStoreRedirectJourneyForUnloadAbandon,
  registerStoreRedirectJourneyForUnloadAbandon,
} from '@/lib/portalJourney';

export const reportStoreRedirectEvent = (
  [eventType, eventData]: StoreRedirectEvent,
  pathname: string
): void => {
  const baseData = {
    ...eventData,
    flow: 'store-redirect',
    pathname,
  };

  if (eventType === EStoreRedirectEventType.STARTED) {
    registerStoreRedirectJourneyForUnloadAbandon({
      destinationHost: eventData.destinationHost,
      journeyId: eventData.journeyId,
      pathname,
      startedAtMilliseconds: Date.now(),
    });
    logPortalRumInfo(EPortalRumEvents.PORTAL_JOURNEY_STARTED, {
      ...baseData,
      phase: 'started',
    });
    return;
  }

  if (eventType === EStoreRedirectEventType.TOKEN_CREATED) {
    logPortalRumInfo(EPortalRumEvents.PORTAL_JOURNEY_STEP_COMPLETED, {
      ...baseData,
      phase: 'step-completed',
      step: 'redirect-token-created',
    });
    return;
  }

  if (eventType === EStoreRedirectEventType.NAVIGATION_DISPATCHED) {
    finishStoreRedirectJourneyForUnloadAbandon(eventData.journeyId);
    logPortalRumInfo(EPortalRumEvents.PORTAL_JOURNEY_COMPLETED, {
      ...baseData,
      phase: 'completed',
    });
    return;
  }

  finishStoreRedirectJourneyForUnloadAbandon(eventData.journeyId);
  logPortalRumError(EPortalRumEvents.PORTAL_JOURNEY_FAILED, {
    ...baseData,
    phase: 'failed',
  });
};
